/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    idx: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      itemList: [{
        cls: 'index',
        name: '首页',
        push: '/',
        icon: 'icon_workbench',
        iconSelected: 'icon_workbench_selected'
      }, {
        cls: 'workbench',
        name: '审核',
        push: '/examine',
        icon: 'icon_checkup',
        iconSelected: 'icon_checkup_selected'
      }, {
        cls: 'workbench',
        name: '我的',
        push: '/me',
        icon: 'icon_me',
        iconSelected: 'icon_me_selected'
      }]
    };
  }
};